import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_PERMISSIONS } from '@modules/affiliate-program-subaffiliate-deals/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IAffiliateProgramSubAffiliateDealsSavePayload,
  IAffiliateProgramSubAffiliateItemResponse,
} from '../types';
import {
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_ITEM_QUERY_KEY,
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_ITEM_URL,
} from '../constants';

export default function useAffiliateProgramSubAffiliateDealsItemQuery(
  id: Ref<number | undefined>,
): IContextQueryResult<IAffiliateProgramSubAffiliateItemResponse, Error, IAffiliateProgramSubAffiliateDealsSavePayload> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAffiliateProgramSubAffiliateItemResponse, Error, IAffiliateProgramSubAffiliateDealsSavePayload>({
    queryKey: [AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_ITEM_QUERY_KEY, id],
    queryFn: async ({ signal }) => fetchGet<IAffiliateProgramSubAffiliateItemResponse>(
      AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_ITEM_URL,
      {
        signal,
        permission: AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_PERMISSIONS.EDIT,
        urlParams: {
          id: id.value,
        },
      },
    ),
    select: (data) => data.subaffiliate_condition,
    enabled: computed(() => !!id.value),
  });
}
